module.exports = __webpack_public_path__ + "media/images/home-penelopa-f0a28f6a5c252972e87cf67bd85c4608.jpg";